<template>
  <div class="dashboard-container">
    <!-- Sidebar (only one place) -->
    <aside class="sidebar">
      <h3><router-link to="/dashboard">Dashboard</router-link></h3>
      <ul>
        <li><router-link to="/dashboard/guests">Manage Guests</router-link></li>
      </ul>
    </aside>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Topbar -->
      <header class="topbar">
        <h2>Dashboard</h2>
        <div class="user-menu">
          <button class="btn-primary" href="#" @click="logout">Logout</button>
          <!-- <div><span>{{ user.name }}</span></div> -->
        </div>
      </header>

      <!-- Slot for child views -->
      <section class="content">
        <slot></slot>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "DashboardLayout",
  data() {
    return {
      user: { name: "Admin" }
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.dashboard-container {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 220px;
  background: #2c3e50;
  color: #fff;
  padding: 20px;
}

.sidebar h3 {
  margin-bottom: 15px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  margin: 10px 0;
}

.sidebar a {
  color: #fff;
  text-decoration: none;
}

.main-content {
  flex: 1;
  padding: 20px;
  background: #f4f6f9;
}

.topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-menu a {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.content {
  margin-top: 20px;
}
.btn-primary {
  padding: 8px 12px;
  background: #ff0000;
  color: #fff;
  border: none;
  border-radius: 4px;
}
</style>
